import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function DutySlipActivity({ dutySlips = [], totalCount = 0, invoicedCount = 0, pendingCount = 0, onPreviewDutySlip, onDownloadWithProgress }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 7;

  const data = Array.isArray(dutySlips) ? dutySlips : [];
  const totalPages = Math.max(1, Math.ceil(data.length / pageSize));
  const currentData = data.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const startItem = data.length > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(currentPage * pageSize, data.length);

  return (
    <div className="dash-card p-2 d-flex flex-column justify-content-between" style={{ height: '100%', minHeight: 260 }}>
      <div className="d-flex flex-column flex-grow-1" style={{ width: '100%', minHeight: 0 }}>
        {/* Header row */}
        <div className="d-flex justify-content-between align-items-center mb-1 px-1 flex-wrap gap-1">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h6 className="m-0 fw-bold" style={{ fontSize: '12.5px', color: '#0f172a' }}>
              Duty Slip Activity
            </h6>
            <div className="d-flex align-items-center gap-2" style={{ fontSize: '9.5px' }}>
              <span style={{ color: '#475569' }}>Total: <b style={{ color: '#0d7a71' }}>{totalCount || data.length}</b></span>
              <span style={{ color: '#cbd5e1' }}>|</span>
              <span style={{ color: '#475569' }}>Invoiced: <b style={{ color: '#0d7a71' }}>{invoicedCount}</b></span>
              <span style={{ color: '#cbd5e1' }}>|</span>
              <span style={{ color: '#475569' }}>Pending: <b style={{ color: '#64748b' }}>{pendingCount}</b></span>
            </div>
          </div>
          <button
            type="button"
            onClick={() => navigate('/Dutyslip')}
            style={{
              fontSize: '11px',
              color: '#0d7a71',
              fontWeight: '700',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }}
          >
            View All
          </button>
        </div>

        {/* Table */}
        <div className="table-responsive flex-grow-1" style={{ width: '100%', padding: '0 1px' }}>
          <table className="dash-pixel-table" style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '19%' }}>DS No.</th>
                <th style={{ width: '31%' }}>Company</th>
                <th style={{ width: '18%' }}>Fare</th>
                <th style={{ width: '12%' }} className="text-center">Action</th>
                <th style={{ width: '20%' }} className="text-center">Invoice Status</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center py-4" style={{ color: '#94a3b8', fontSize: '11px' }}>
                    No duty slip activity found
                  </td>
                </tr>
              ) : currentData.map((row, i) => {
                const fareType = row.fareType || '-';
                const isReceivable = fareType === 'Receivable';
                const isPayable = fareType === 'Payable';
                const isGenerated = row.invoiceStatus === 'Invoiced' || (row.invoiceNo && row.invoiceNo !== '-');

                return (
                  <tr key={i}>
                    <td>
                      <div style={{ color: '#0d7a71', fontWeight: '600' }}>{row.dsNo}</div>
                      {row.date && (
                        <div style={{ fontSize: '9px', color: '#64748b' }}>{row.date}</div>
                      )}
                    </td>
                    <td style={{ color: '#1e293b', fontWeight: '600' }}>
                      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row.company}>
                        {row.company}
                      </div>
                    </td>
                    <td>
                      <span
                        style={{
                          fontSize: fareType === '-' ? '12px' : '10.5px',
                          fontWeight: '700',
                          color: fareType === '-' ? '#94a3b8' : (isReceivable ? '#064e48' : '#0369a1')
                        }}
                      >
                        {fareType}
                      </span>
                    </td>
                    <td className="text-center">
                      <div className="d-inline-flex align-items-center justify-content-center gap-1">
                        <button
                          type="button"
                          className="border-0 bg-transparent p-0"
                          title="Download Duty Slip PDF"
                          onClick={() => onDownloadWithProgress && onDownloadWithProgress('dutyslip', { DutySlipNo: row.id, ...row })}
                          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        >
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="#e53e3e">
                            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                          </svg>
                        </button>
                        <button
                          type="button"
                          className="border-0 bg-transparent p-0"
                          title="Preview Duty Slip Document"
                          onClick={() => onPreviewDutySlip && onPreviewDutySlip({ DutySlipNo: row.id, ...row })}
                          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="#0d7a71">
                            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                          </svg>
                        </button>
                      </div>
                    </td>
                    <td className="text-center">
                      <span className={`pill-badge ${isGenerated ? 'pill-generated' : 'pill-not-generated'}`}>
                        {isGenerated ? 'Generated' : 'Not Generated'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination Footer */}
      <div className="d-flex justify-content-between align-items-center mt-auto pt-1 border-top px-1" style={{ fontSize: '10px' }}>
        <span style={{ color: '#64748b' }}>
          {data.length > 0 ? `Showing ${startItem}–${endItem} of ${data.length}` : '0 of 0'}
        </span>
        <div className="d-flex align-items-center gap-1">
          <button
            type="button"
            className="dash-page-btn"
            disabled={currentPage <= 1}
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
          >
            ‹
          </button>
          <button
            type="button"
            className="dash-page-btn"
            disabled={currentPage >= totalPages}
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
          >
            ›
          </button>
        </div>
      </div>
    </div>
  );
}
